import * as React from 'react';
var Download = function (_a) {
    var title = _a.title, titleId = _a.titleId;
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId },
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M13 3v11.528l2.56-2.124 1.277 1.539-4.198 3.484a1 1 0 0 1-1.278 0l-4.198-3.484 1.278-1.54L11 14.529V3h2Z", fill: "evenodd" }),
        React.createElement("path", { d: "M4.876 9.398 2.807 21.072h18.386L19.124 9.398h-4.695v2h3.018l1.36 7.674H5.193l1.36-7.674H9.57v-2H4.876Z", fill: "evenodd" })));
};
export default Download;
//# sourceMappingURL=Download.js.map